import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ApiUserCourseService {
    relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.userCourses.url}/api/v1/UserCourses/user`;
    }

    getProgressionByUserIdCourseId(userId: string, courseId: string): Observable<any> {
        return this.http.get<any>(`${this.relativePath}/${userId}/course/${courseId}/progression`);
    }

    getZipCertificatesUrl(requestId: string): Observable<string> {
        return this.http.get(`${this.relativePath}/certificates/request-certificates/${requestId}/file-url`, {
            responseType: "text"
        });
    }
}
